module.exports = __webpack_public_path__ + "static/media/Boton_Tecos.7aab9a2a.webp";